import type { FunctionComponent } from "react";

export const AutoheldenLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/autohelden_logo.jpg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Autohelden"
    />
  );
};
